export default __webpack_public_path__ + "img/ckiNShtF.cf0ee747.svg";